export type TAPIResponse<Data, Error> = {
    data: undefined | Data;
    error: undefined | null | Error;
    loaded: boolean;
    isLoading: boolean;
};

export const enum SortEnum {
    ASC = "asc",
    DESC = "desc",
}
